// removed by extract-text-webpack-plugin
module.exports = {"primary":"#00B0EB","primaryLight":"#66D1F4","onPrimaryTextColor":"white","logoRow":"Header__logoRow___2mCcG","phoneNumber":"Header__phoneNumber___1RmvK","icon":"Header__icon___3ePrq","logo":"Header__logo___pQrVh","clientDetailsRow":"Header__clientDetailsRow___2jX8e","sidebarToggleWrapper":"Header__sidebarToggleWrapper___1MgRR","navbarToggle":"Header__navbarToggle___39xbm","iconBar":"Header__iconBar___FGQn1","greeting":"Header__greeting___3_veD","accountNumberLogout":"Header__accountNumberLogout___2bNQ5","accountNumber":"Header__accountNumber___1wWTL","logout":"Header__logout___3aGpv"};


//////////////////
// WEBPACK FOOTER
// ./client/components/layout/Header/Header.css
// module id = 2006
// module chunks = 0